import React, { useEffect, useState } from 'react'
import Grid from '@mui/material/Grid2';
import { faAngleRight } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { useNavigate } from 'react-router-dom';
import SettingsTabs from '../../components/common/SettingsTabs';
import { apiService } from '../../services/apiService';
import { toast } from 'react-toastify';
function SettingsS3file() {
    const navigate = useNavigate();
    const [formData, setFormData] = useState({
        AWS_SECRET_ACCESS_KEY: '',
        AWS_ACCESS_KEY_ID: '',
        AWS_DEFAULT_REGION: '',
        AWS_BUCKET: '',
        MAIL_PASSWORD: '',
        AWS_URL: '',
        AWS_ENDPOINT: '',
    });
    const [errors, setErrors] = useState({});
    const [btnloading, setBtnLoading] = useState(false);
    const [loading, setLoading] = useState(false);
    const [cancel, setCancels] = useState(false);
    const [errorsmessage, setErrorMessage] = useState('');
    useEffect(() => {
        const fetchUserData = async () => {
            setLoading(true);
            try {
                const response = await apiService.postRequest(`/admin/get-protected-settings?settings_type=s3_file_system`);
                const generaldata = response.data;
                setFormData({
                    AWS_SECRET_ACCESS_KEY: generaldata.AWS_SECRET_ACCESS_KEY || '',
                    AWS_ACCESS_KEY_ID: generaldata.AWS_ACCESS_KEY_ID || '',
                    AWS_DEFAULT_REGION: generaldata.AWS_DEFAULT_REGION || '',
                    AWS_BUCKET: generaldata.AWS_BUCKET || '',
                    MAIL_PASSWORD: generaldata.MAIL_PASSWORD || '',
                    AWS_URL: generaldata.AWS_URL || '',
                    AWS_ENDPOINT: generaldata.AWS_ENDPOINT || '',
                });
            } catch (error) {
                console.error("Error fetching user data", error);
            }finally {
                setCancels(false);
                setLoading(false);
            }
        };

        fetchUserData();
    }, [cancel]);
    // Clear specific errors when inputs are modified
    const handleInputChange = (e) => {
        const { name, value } = e.target;
        setFormData({ ...formData, [name]: value });

        // Clear the error for the changed field
        if (errors[name]) {
            setErrors({ ...errors, [name]: '' });
        }
    };
    
    const handleSubmit = async (e) => {
        e.preventDefault();

        const data = new FormData();
        data.append('AWS_SECRET_ACCESS_KEY', formData.AWS_SECRET_ACCESS_KEY);
        data.append('AWS_ACCESS_KEY_ID', formData.AWS_ACCESS_KEY_ID);
        data.append('AWS_DEFAULT_REGION', formData.AWS_DEFAULT_REGION);
        data.append('AWS_BUCKET', formData.AWS_BUCKET);
        data.append('MAIL_PASSWORD', formData.MAIL_PASSWORD);
        data.append('AWS_URL', formData.AWS_URL);
        data.append('AWS_ENDPOINT', formData.AWS_ENDPOINT);
        
        // if (formData.site_logo) {
        // }

        setBtnLoading(true);
        try {
            const response = await apiService.postRequest('/admin/save-aws-settings', data);
            if (response && response.success === true) {
                // navigate('/user/member');
                toast(response.message || "Settings saved successfully!");
            } else {
                setErrorMessage(response.message || "Failed. Please try again");
                if (response.errors) {
                    setErrors(response.errors);
                }
                if(response && response.authenticate === false){
                    await apiService.postRequest('/auth/logout');
                    localStorage.clear();
                    sessionStorage.clear();
                    window.location.href = '/login';
                }
            }
        } catch (error) {
            console.error('Error adding user:', error);
        } finally {
            setBtnLoading(false);
        }
    }; 
        
  return (
    <div className='container-fluid px-0'>
        <div className='content_container'>
            <Grid size={{sm:12}} container className="main_jobseeker">
                <Grid size={{sm:12}} container alignItems="center">
                    <Grid size={{md:12,xs:12}} container flexDirection="column" className="jobseekerhead">
                        <h3>Company Settings</h3>
                        <span><b onClick={()=>navigate("/dashboard")}>Dashboard</b> <FontAwesomeIcon className='angleright' icon={faAngleRight} /> Company Settings <FontAwesomeIcon className='angleright' icon={faAngleRight} /> SMTP</span>
                    </Grid>
                    <Grid size={{xs:12}} container justifyContent="flex-start" className="statusselectbtn my-5">
                        <SettingsTabs/>
                    </Grid>
                    <Grid size={{xs:12}} container justifyContent="center">
                    {loading ? 
                    <div className='d-flex justify-content-center w-100'>
                        <img style={{ width: "100px" }} src={require('../../assets/pinkloader.gif')} alt='Loading...' />
                    </div> :<>
                        <form className='row justify-content-center w-100' onSubmit={handleSubmit}>
                            <Grid size={{sm:12,xs:12}} container justifyContent="space-between" className="regiter_inputs i94validateinput">
                                <Grid size={{sm:5.5, xs:12}} container flexDirection="column" >
                                    <span>AWS_Access_Key_Id<small className='red_starimpo'>*</small></span>
                                    <input type="text" name="AWS_ACCESS_KEY_ID" value={formData.AWS_ACCESS_KEY_ID} onChange={handleInputChange}/>
                                    {errors.AWS_ACCESS_KEY_ID && <p style={{color:"red"}}>{errors.AWS_ACCESS_KEY_ID}</p>}
                                </Grid>
                                <Grid size={{sm:5.5, xs:12}} container flexDirection="column" >
                                    <span>AWS_Secret_Access_Key<small className='red_starimpo'>*</small></span>
                                    <input type="text" name="AWS_SECRET_ACCESS_KEY" value={formData.AWS_SECRET_ACCESS_KEY} onChange={handleInputChange} />
                                    {errors.AWS_SECRET_ACCESS_KEY && <p style={{color:"red"}}>{errors.AWS_SECRET_ACCESS_KEY}</p>}
                                </Grid>
                                <Grid size={{sm:5.5, xs:12}} container flexDirection="column" >
                                    <span>AWS_Default_Region<small className='red_starimpo'>*</small></span>
                                    <input type="text" name="AWS_DEFAULT_REGION" value={formData.AWS_DEFAULT_REGION} onChange={handleInputChange}/>
                                    {errors.AWS_DEFAULT_REGION && <p style={{color:"red"}}>{errors.AWS_DEFAULT_REGION}</p>}
                                </Grid>
                                <Grid size={{sm:5.5, xs:12}} container flexDirection="column" >
                                    <span>AWS_Bucket<small className='red_starimpo'>*</small></span>
                                    <input type="text" name="AWS_BUCKET" value={formData.AWS_BUCKET} onChange={handleInputChange}/>
                                    {errors.AWS_BUCKET && <p style={{color:"red"}}>{errors.AWS_BUCKET}</p>}
                                </Grid>
                                <Grid size={{sm:5.5, xs:12}} container flexDirection="column" >
                                    <span>AWS_URL<small className='red_starimpo'>*</small></span>
                                    <input type="text" name="AWS_URL" value={formData.AWS_URL} onChange={handleInputChange}/>
                                    {errors.AWS_URL && <p style={{color:"red"}}>{errors.AWS_URL}</p>}
                                </Grid>
                                <Grid size={{sm:5.5, xs:12}} container flexDirection="column" >
                                    <span>AWS_Endpoint<small className='red_starimpo'>*</small></span>
                                    <input type="text" name="AWS_ENDPOINT" value={formData.AWS_ENDPOINT} onChange={handleInputChange}/>
                                    {errors.AWS_ENDPOINT && <p style={{color:"red"}}>{errors.AWS_ENDPOINT}</p>}
                                </Grid>
                                {errorsmessage && <p style={{ color: 'red' }}>{errorsmessage}</p>}
                            </Grid>
                            <Grid size={{sm:12,xs:12}} container className="gap-3 my-3">
                                <button type='button' className='registersendbtn1' onClick={()=>setCancels(true)}>Cancel</button>
                                <button type="submit" className='registersendbtn2'>{btnloading ? <img src={require('../../assets/whiteloader.gif')} alt=''/> : 'Save'}</button>
                            </Grid>
                        </form>
                    </>}
                    </Grid>
                </Grid>
            </Grid>
        </div>
    </div>
  )
}

export default SettingsS3file
